import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNav,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

const HeaderWithCenteredLogoAndNavDesktop = () => (
  <>
    <HeaderRow borderless type="medium">
      <HeaderSection justify="start">
        <StoreLocator />
      </HeaderSection>
      <HeaderSection justify="center">
        <HeaderLogo center fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <MedRecSwitch />
        <SearchHeader withEmbeddedInput />
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="flat" withNavbar>
      <HeaderSection justify="center">
        <HeaderNav />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithCenteredLogoAndNavDesktop };
